import { MatSort } from "@angular/material/sort";
import { MatDataSource } from "../shared-new/util/mat-datasource";
import { VetMemberAccountModel } from "../models/vet-users/vet-member-account.model";


export class AccountManagementDataSource extends MatDataSource<VetMemberAccountModel> {
  public constructor(data: VetMemberAccountModel[], sort: MatSort) {
    super(data, sort);
    this.setFilterPredicate();
  }


  updateVetAccount(memberId: number, viewAccess: string, submitAccess: string): void {
    const index = this.data.findIndex(member => member.memberId === memberId);
    if (index !== -1) {
      const updatedAccount = {
        ...this.data[index],
        viewAccess: viewAccess,
        submitAccess: submitAccess,
        //status: status
      };
      const updatedData = [...this.data];
      updatedData[index] = updatedAccount;

      // Update the data array to trigger change detection
      this.data = updatedData;
    }
  }

  setFilterPredicate(): void {
    this.filterPredicate = (saleHorse: VetMemberAccountModel, filterValue: string = '') => {
      return 'clinic,vetName,address,countryName,emailAddress,memberName,mobile,phoneNumber1,phoneNumber2,postCode,stateName,status,viewAccess,submitAccess,organisationID,saleAccess,saleName'
        .split(',')
        .some((key) => {
          return (
            saleHorse[key as keyof VetMemberAccountModel] &&
            new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
              saleHorse[key as keyof VetMemberAccountModel]
            )
          );
        });
    };
  }
}
